import { useApiClient } from '~/api-client';
import { CoordinatesForm, MasterlocationsgeocautionsResource } from '@mark43/rms-api';
import { useQuery } from '@tanstack/react-query';

const MAP_LOCATION_GEO_CAUTIONS_CACHE_KEY = 'map-location-geo-cautions';

export function useEsriMapLocationCautions(coordinatesForm: CoordinatesForm) {
    const apiClient = useApiClient();

    const mapLocationGeoCautionsQuery = useQuery(
        [MAP_LOCATION_GEO_CAUTIONS_CACHE_KEY, coordinatesForm],
        () => {
            return apiClient
                .request<MasterlocationsgeocautionsResource.GetGeoCautionsForFullAddress>({
                    method: 'POST',
                    url: 'master/locations/geocautions/by_location',
                    service: 'RMS',
                    data: coordinatesForm,
                })
                .then((response) => {
                    return response?.data?.data;
                })
                .catch(() => {
                    throw Error('Error while fetching location geocautions');
                });
        },
        {
            enabled: coordinatesForm && !!coordinatesForm.address,
        }
    );

    return mapLocationGeoCautionsQuery;
}
